import { useState, useEffect } from "react";

interface UsePdfLambdaProps {
  id: number;
  locale: string | undefined;
  type: "product" | "news";
}

export const usePdfLambda = ({ locale = "en", id, type }: UsePdfLambdaProps) => {
  const [origin, setOrigin] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.origin) {
      setOrigin(window.location.origin);
    }
  }, []);

  if (!origin) {
    return null;
  }

  return `${origin}/api/robe/pdfs/${locale}/${type}/${id}`;
};
